module.exports = __webpack_public_path__ + "img/nav_index1.6d8ac60d.gif";